import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectChangedNodes = (state: AppStateType) => state.changedNodes;
export const selectChangedNodesState = createSelector([selectChangedNodes], changedNodes => {
  return changedNodes.data;
});
